import { render, staticRenderFns } from "./FontSizeSlider.vue?vue&type=template&id=f22fc7e2&"
import script from "./FontSizeSlider.vue?vue&type=script&lang=js&"
export * from "./FontSizeSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports